<template>
  <div>
    <tk-ask-us-dialog v-model="showAskUsDialog" topic="taiko" />
    <v-navigation-drawer v-model="$app.drawer" app temporary :width="320" class="pl-2 pb-5">
      <div class="text-xs-right pa-2">
        <tk-lang-btns isDrawer @selected="$app.drawer = false" />
      </div>

      <v-layout align-center>
        <v-flex shrink>
          <tk-btn aria-label="Cloe" icon small @click="$app.drawer = false">
            <v-icon size="30">fas fa-times</v-icon>
          </tk-btn>
        </v-flex>
        <v-flex ml-3>
          <TkLogo />
        </v-flex>
      </v-layout>

      <tk-search-input class="mr-3 ml-1 mt-3" @click:append="goToSearch" />

      <v-list class="my-2 list-with-checboxes">
        <v-list-tile v-for="item in categories" :key="item.title">
          <v-list-tile-action>
            <v-checkbox
              color="primary"
              v-model="selectedCatgories"
              hide-details
              :ripple="false"
              :value="item"
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <div class="mr-3 ml-1">
        <tk-btn
          color="black"
          dark
          block
          large
          v-text="$t('SEARCH.FILTER_SUBMIT')"
          @click="goToSearch"
        />
      </div>

      <v-list class="mt-4">
        <v-list-tile to="/search">
          <v-list-tile-title class="link" v-text="$t('MENU.WHATS_NEW')"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/giftcard">
          <v-list-tile-title class="link" v-text="$t('MENU.GIFT_CARD')"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile class="link" to="/newsletter">
          <v-list-tile-title class="link" v-text="$t('MENU.NEWSLETTER')"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/news">
          <v-list-tile-title class="link" v-text="$t('MENU.NEWS')"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/contact">
          <v-list-tile-title class="link" v-text="$t('MENU.CONTACT_US')"></v-list-tile-title>
        </v-list-tile>
        <template v-if="$auth.currentUser">
          <v-list-tile :to="{name: 'profile.account'}">
            <v-list-tile-title class="link" v-text="$auth.currentUser.name" />
          </v-list-tile>
          <v-list-tile @click="$app.drawer = false; logout()">
            <v-list-tile-title class="link" v-text="$t('COMMON.LOGOUT')" />
          </v-list-tile>
        </template>

        <v-list-tile v-else @click="$app.drawer = false; $app.loginDialog = true">
          <v-list-tile-content>
            <v-list-tile-title class="link" v-text="$t('COMMON.LOGIN')" />
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="mt-4">
        <v-list-tile :href="'mailto:' + email">
          <v-list-tile-title class="link" v-text="email"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile :href="'tel:' + phone">
          <v-list-tile-title class="link" v-text="phone"></v-list-tile-title>
        </v-list-tile>
      </v-list>
      <tk-btn
        dark
        v-text="$t('ARTWORK.ASK_US')"
        @click="$app.drawer = false; showAskUsDialog = true"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import TkLangBtns from "@/components/core/TkLangBtns";
import TkLogo from "@/components/core/TkLogo";
import { companyEmail, companyPhone, categories } from "@/config";
import TkAskUsDialog from "@/components/core/TkAskUsDialog";
import TkSearchInput from "@/components/core/TkSearchInput";
import { SearchFilters } from "@/services/search/SearchFilters";

export default {
  name: "tk-drawer",

  components: {
    TkLangBtns,
    TkLogo,
    TkAskUsDialog,
    TkSearchInput
  },

  data: () => ({
    phone: companyPhone,
    email: companyEmail,
    showAskUsDialog: false,
    categories: categories,
    selectedCatgories: [],
    filters: new SearchFilters({})
  }),

  methods: {
    logout() {
      this.$auth.logout();
      if (this.$route.name === "home") return;
      this.$router.replace({ name: "home" });
    },

    async goToSearch() {
      const items = [];

      this.selectedCatgories.forEach(cat => {
        cat.techniques.forEach(t => {
          items.push({ slug: t });
        });
      });

      // Replaces selected technques
      this.filters.techniquesSelected = items;

      try {
        await this.$router.push({
          name: "search",
          query: this.filters.toQuery()
        });
      } catch (error) {
        console.log("Error", error);
      }

      this.$app.drawer = false;
    }
  }
};
</script>